/**
 * Every key the super top-up journey stores or caches under. Its own namespace (`stu-`), never
 * another journey's: one browser tab can hold both journeys, and neither may read
 * the other's quote, selection or draft. `PERSIST` is the app-wide marker the query persister
 * looks for, so it keeps its shared value.
 */

export const STU_QUERY_KEYS = {
  CREATE_LEAD: 'stu-create-lead',
  UPDATE_LEAD: 'stu-update-lead',
  GET_CONFIG: 'stu-get-config',
  RETAIL_HEALTH_INSURANCE_QUOTES: 'stu-retail-health-insurance-quotes',
  CREATE_QUOTE: 'stu-create-quote',
  GET_QUOTE: 'stu-get-quote',
  GET_SELECTION: 'stu-get-selection',
  UPDATE_SELECTION: 'stu-update-selection',
  COMMIT_SELECTION: 'stu-commit-selection',
  GET_PROPOSAL_QUESTIONS: 'stu-get-proposal-questions',
  SAVE_PROPOSAL_ANSWERS: 'stu-save-proposal-answers',
  UPLOAD_PROPOSAL_DOCUMENT: 'stu-upload-proposal-document',
  AFFIRM_PROPOSAL: 'stu-affirm-proposal',
  SUBMIT_PROPOSAL: 'stu-submit-proposal',
  GET_PAYMENT_SUMMARY: 'stu-get-payment-summary',
  INITIATE_PAYMENT: 'stu-initiate-payment',
  GET_PAYMENT_STATUS: 'stu-get-payment-status',
  GET_POLICY_DOCUMENT: 'stu-get-policy-document',
  GET_KYC_FORM: 'stu-get-kyc-form',
  INITIATE_KYC: 'stu-initiate-kyc',
  VERIFY_KYC_OTP: 'stu-verify-kyc-otp',
  GET_KYC_STATE: 'stu-get-kyc-state',
  ACCEPT_KYC_PRICE: 'stu-accept-kyc-price',
  GET_PINCODE: 'stu-get-pincode',
  GET_IFSC: 'stu-get-ifsc',
  VERIFY_OTP: 'stu-verify-otp',
  CREATE_SUPERLEAP_OPPORTUNITY: 'stu-create-superleap-opportunity',
  GET_JOURNEY_LIST: 'stu-get-journey-list',
  PERSIST: 'persist',
} as const;

export const STU_SESSION_KEYS = {
  BENEFIT_ID: 'stu-benefit-id',
  LEAD_ID: 'stu-lead-id',
  QUOTE_ID: 'stu-quote-id',
  QUOTE_REQUEST: 'stu-quote-request',
  EFFECTIVE_PARAMS: 'stu-effective-params',
  SELECTED_PLAN_ID: 'stu-selected-plan-id',
  OPTION_CODE: 'stu-option-code',
  SELECTED_MEMBERS: 'stu-selected-members',
  SELECTED_MEMBERS_FORM: 'stu-selected-members-form',
  PROPOSAL_ID: 'stu-proposal-id',
  CARRIED_PLAN_ID: 'stu-carried-plan-id',
  KYC_RESEND_COUNT: 'stu-kyc-resend-count',
  RESUME_RETURN: 'stu-resume-return',
} as const;

export const STU_TTL_VALUES = {
  SELECTED_MEMBERS: 10 * 60 * 1000, // 10 minutes
  PINCODE: 24 * 60 * 60 * 1000, // 24 hours, the server's max-age
  IFSC: 24 * 60 * 60 * 1000, // 24 hours, the server's max-age
} as const;

export const STU_TIMEOUT_VALUES = {
  QUOTE_POLL_INTERVAL_MS: 3 * 1000, // 3 seconds
  QUOTE_POLL_TIMEOUT_MS: 60 * 1000, // 60 seconds
  PAYMENT_POLL_INTERVAL_MS: 4 * 1000, // 4 seconds
  /** How long the return screen shows its spinner before saying the payment is taking longer. */
  PAYMENT_WAIT_MS: 30 * 1000, // 30 seconds
  /** After that wait, the screen keeps checking in the background, less often. */
  PAYMENT_SLOW_POLL_INTERVAL_MS: 15 * 1000, // 15 seconds
  /** Background checks stop here; "Check payment status" starts them again. */
  PAYMENT_POLL_CEILING_MS: 10 * 60 * 1000, // 10 minutes
} as const;
